import { createResource } from '@atlassian/react-resource-router';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-knowledge-base-ai-draft-generate", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-ai-draft-generate" */ './get-data'
	);

export const servicedeskKnowledgeBaseAiDraftGenerateResource = createResource({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_AI_DRAFT_GENERATE',
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader,
	maxAge: Infinity,
	isBrowserOnly: true,
});
